import styled from 'styled-components';

export const PriceInfoLoaderWrapper = styled.div`
  position: relative;
  min-height: 45px;
`;

export const PriceInfoLoaderOverlay = styled.div`
  position: absolute;
  left: 35px;
  top: -3px;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
